import { useMutation } from "@tanstack/react-query";
import { parseResponse } from "lib/fetch";
import type { ReportUserInterface } from "types/reportUser";
import { createReportUserRequest } from "lib/api/reportUser";

export const createReportUser = (data: HashMap<unknown>) =>
    parseResponse<ReportUserInterface>(createReportUserRequest(data));

export const reportUserKeys = {
    all: ["reportUser"] as const,
};

export const useCreateReportUser = () =>
    useMutation({
        mutationFn: (data: HashMap<unknown>) => createReportUser(data),
    });
